import { HisSearch, HisSearchCriteria, HisSearchCriteriaGroup, HisSearchCriteriaOperator, HisSearchGroup } from './his-search';
import { HisSearchConstants } from './his-search-constants';
import { HisSearchItem } from './his-search-item';

/**
 * Parser zum Codieren und dekodieren des eines Objekts {@linkcode HisSearch},
 * dass die Parameter als flat Object für die Suche in der URL übergibt.
 *
 * WICHITG: Die indexe grops1.criteria0 beschreiben nicht die Position der Elemente in der Scuhkonfigurationsdatei,
 * sondern guppieren lediglich zusammengehöriges.
 */
export class HisSearchParser {

    /**
     * Encodes the HisSearch
     *
     * @returns an array of HisSearchItem
     */
    public static encode(search: HisSearch): HisSearchItem[] {
        let searchItems: HisSearchItem[] = [];

        searchItems.push(new HisSearchItem(HisSearchConstants.SEARCH_CONFIG_FILE, search.configFile));

        for (let group of search.groups) {
            let groupWithIndex = HisSearchConstants.GROUPS + search.groups.indexOf(group) + '.';
            searchItems.push(new HisSearchItem(groupWithIndex + HisSearchConstants.GROUP_LABEL, group.groupLabel));
            console.log('his-search-parser#encode() #criteriaGroupAnd', group.criteriaGroupAnd);

            if (group.criteriaGroupAnd === true) {
                searchItems.push(new HisSearchItem(groupWithIndex + HisSearchConstants.CRITERIA_GROUP_AND, 'true'));
            }
            if (group.criteriaGroupAnd === false) {
                searchItems.push(new HisSearchItem(groupWithIndex + HisSearchConstants.CRITERIA_GROUP_AND, 'false'));
            }
            if (group.criteria) {
                for (let criteria of group.criteria) {
                    let criteriaWithIndex = groupWithIndex +  HisSearchConstants.CRITERIA + group.criteria.indexOf(criteria) + '.';
                    //                    outcommented because of Hiszilla #245049
                    //                    if (!criteria.value ) {
                    //                        continue;
                    //                    }

                    searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.FIELD, criteria.field));
                    searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.VALUE, criteria.value));

                    if (criteria.not) {
                        searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.NOT, String(criteria.not)));
                    }
                    if (criteria.operator) {
                        searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.OPERATOR, criteria.operator));
                    }
                }
            }
            if (group.criteriaGroups) {
                for (let criteriaGroup of group.criteriaGroups) {
                    let criteriaGroupWithIndex =
                        groupWithIndex +
                        HisSearchConstants.CRITERIA_GROUPS +
                        group.criteriaGroups.indexOf(criteriaGroup) + '.';

                    if (criteriaGroup.excluding) {
                        searchItems.push(new HisSearchItem(
                            criteriaGroupWithIndex + HisSearchConstants.EXCLUDING,
                            String(criteriaGroup.excluding)));
                    }

                    for (let criteria of criteriaGroup.criteria) {
                        let criteriaGroupCriteriaWithIndex = criteriaGroupWithIndex +
                            HisSearchConstants.CRITERIA + criteriaGroup.criteria.indexOf(criteria) + '.';

                        if (!criteria.value) {
                            continue;
                        }

                        searchItems.push(new HisSearchItem(criteriaGroupCriteriaWithIndex + HisSearchConstants.FIELD, criteria.field));
                        searchItems.push(new HisSearchItem(criteriaGroupCriteriaWithIndex + HisSearchConstants.VALUE, criteria.value));

                        if (criteria.not) {
                            searchItems.push(new HisSearchItem(
                                criteriaGroupCriteriaWithIndex + HisSearchConstants.NOT, String(criteria.not)));
                        }
                        if (criteria.operator) {
                            searchItems.push(new HisSearchItem(
                                criteriaGroupCriteriaWithIndex + HisSearchConstants.OPERATOR, criteria.operator));
                        }
                    }
                }
            }
        }

        return searchItems;
    }

    /**
     * Decodes an array of HisSearchItem
     *
     * @param hisSearchItems an array of HisSearchItem
     *
     * @returns a new instance of HisSearch
     */
    public static decode(hisSearchItems: HisSearchItem[]): HisSearch {
        let searchItems = this.filterKeys(hisSearchItems);

        let search = new HisSearch();

        search.configFile = this.getValueForKey(HisSearchConstants.SEARCH_CONFIG_FILE, undefined, searchItems);

        let groupsWithIndex = this.getGroupIndexes(searchItems);

        for (let groupIndex of groupsWithIndex) {
            let groupPrefixWithIndex = HisSearchConstants.GROUPS + groupIndex;

            let groupItems: HisSearchItem[] = searchItems.filter(item => item.key.startsWith(groupPrefixWithIndex));
            let group: HisSearchGroup = new HisSearchGroup();

            group.groupLabel = this.addGroupLabel(groupPrefixWithIndex, groupItems);
            group.criteriaGroupAnd = this.addGroupConcatedWithAND(groupPrefixWithIndex, groupItems);

            let criteriaItems = this.getCriteriaItemsForGroup(groupPrefixWithIndex, groupItems);
            let searchCriteria: HisSearchCriteria[] = this.getSearchCriteria(groupPrefixWithIndex, criteriaItems);
            for (let criterion of searchCriteria) {
                // console.log('searchCriterion', searchCriterion);
                group.criteria.push(criterion);
            }

            this.addCriteriaGroupItems(groupPrefixWithIndex, groupItems, group);
            search.groups.push(group);
        }

        return search;
    }

    /**
     * Filters the duplicate searchItem keys and searchItems without values
     *
     * @returns an array of filtered HisSearchItem
     */
    static filterKeys(searchItems: HisSearchItem[]): HisSearchItem[] {
        let filteredSearchItems: HisSearchItem[] = [];
        let keyUnifierMap = new Map();
        for (let item of searchItems) {
            if (item.value) {
                keyUnifierMap.set(item.key, item.value);
            }
        }
        for (let key of keyUnifierMap.keys()) {
            filteredSearchItems.push(new HisSearchItem(key, keyUnifierMap.get(key)));
        }
        return filteredSearchItems;
    }

    /**
     * Adds the criteriaGroup items to the group
     *
     * @param groupPrefixWithIndex the prefix of the group with the index, e. g. group[0]
     * @param groupItems the hisSearchItems of this group, e. g. for the group[0]
     * @param group the searchGroup to which the values are added
     * TODO do not hand over params that are gonna chaned (here group), return the values for these params
     */
    static addCriteriaGroupItems(groupPrefixWithIndex: string, groupItems: HisSearchItem[], group: HisSearchGroup) {
        let criteriaGroupPrefixes: Set<number> =
            this.getIndexesOfType(groupPrefixWithIndex, HisSearchConstants.CRITERIA_GROUPS, groupItems);

        group.criteriaGroups = [];

        for (let criteriaGroupIndex of criteriaGroupPrefixes) {
            // criteriaGroupPrefix = group[0].criteriaGroup[0]
            let criteriaGroupWithIndex = groupPrefixWithIndex + '.' + HisSearchConstants.CRITERIA_GROUPS + criteriaGroupIndex;
            // console.log('criteriaGroupWithIndex', criteriaGroupWithIndex);

            let newCriteriGroup = new HisSearchCriteriaGroup();
            let excluding = groupItems.find(item => item.key.startsWith(criteriaGroupWithIndex + '.' + HisSearchConstants.EXCLUDING));
            if (excluding) {
                if (excluding.value === 'true') {
                    newCriteriGroup.excluding = true;
                } else {
                    newCriteriGroup.excluding = false;
                }
            }

            // add criteriaGroup criteria
            let searchCriteria: HisSearchCriteria[] = this.getSearchCriteria(criteriaGroupWithIndex, groupItems);
            for (let searchCriterion of searchCriteria) {
                newCriteriGroup.criteria.push(searchCriterion);
            }

            group.criteriaGroups.push(newCriteriGroup);
        }
    }

    /**
     * Gets the indexes of the type. E. g. type= CRITERIA, the indexes are maybe criteria[0], criteria[1], criteria[2]
     * so the returned indexes are 0,1,2
     *
     * @param prefixWithIndex e. g. group[0]
     * @param type one of both CRITERIA or CRITERIA_GROUPS
     * @param searchItems an array of {@linkcode HisSearchItem}
     * <ul>
     * <li> groups[0].criteria[0].field </li>
     * <li> groups[0].criteriaGroups[1] </li>
     * <li> groups[0].criteriaGroups[0].criteria[0]</li>
     * </ul>
     *
     * @returns a {@linkcode Set} of numbers
     * <ul>
     * <li> if prefixWithIndex=groups[0], type=CRITERIA, then groups[0].criteria[0], groups[0].criteria[1],
     *      etc. returned value will be 0,1</li>
     * <li> if prefixWithIndex=groups[0], type=CRITERIA_GROUPS, then groups[0].criteriaGroups[0], groups[0]
     *      .criteriaGroups[1], etc. returned value will be 0,1</li>
     * <li> if prefixWithIndex=groups[0].criteriaGroups[0], type=CRITERIA, then groups[0].criteriaGroups[0]
     *      .criteria[0], etc. returned value will be 0</li>
     * </ul>
     */
    static getIndexesOfType(prefixWithIndex: string, type: string, searchItems: HisSearchItem[]): Set<number> {
        // console.log('his-search-parser#getIndexesOfType#searchItems', searchItems);
        if (!type) {
            return new Set<number>();
        }
        if (type !== HisSearchConstants.CRITERIA && type !== HisSearchConstants.CRITERIA_GROUPS) {
            return new Set<number>();
        }

        let indexes: Set<number> = new Set();
        for (let item of searchItems) {
            if (!item.key.startsWith(prefixWithIndex)) {
                continue;
            }

            // Beispiele:
            // groups0.criteria1.field
            // groups0.criteriaGroups1.criteria1.field
            let itemKeyWithoutPrefix = item.key.replace(prefixWithIndex + '.', '');
            // console.log('his-search-parser#getIndexesOfType#itemKeyWithoutPrefix', itemKeyWithoutPrefix);
            // itemKeyWithoutPrefix soll nun criteriaGroups1.criteria1.field

            // Ziffer ermitteln aus z. B.
            // Beispiele:
            // criteria1.field
            // criteriaGroups1.criteria1.field
            if (type === HisSearchConstants.CRITERIA_GROUPS && itemKeyWithoutPrefix.startsWith(HisSearchConstants.CRITERIA_GROUPS)) {
                indexes.add(this.extractIndex(itemKeyWithoutPrefix, type));
                continue;
            } else if (type === HisSearchConstants.CRITERIA && !itemKeyWithoutPrefix.startsWith(HisSearchConstants.CRITERIA_GROUPS)) {
                // itemKeyWithoutPrefix.startsWith(HisSearchConstants.CRITERIA)
                indexes.add(this.extractIndex(itemKeyWithoutPrefix, type));
            }

        }
        return indexes;
    }

    private static extractIndex(itemKeyWithoutPrefix: string, type: string): number {
        let elementWithIndex = itemKeyWithoutPrefix.substring(0, itemKeyWithoutPrefix.indexOf('.'));
        let index = elementWithIndex.replace(type, '');
        //        console.log('his-search-parser#extractIndex#itemKeyWithoutPrefix', itemKeyWithoutPrefix);
        console.log('his-search-parser#extractIndex', '#itemKeyWithoutPrefix', itemKeyWithoutPrefix, '#type', type, '#index', index);
        return +index;
    }

    static getCriteriaItemsForIndex(criteriaWithIndex: string, searchItems: HisSearchItem[]): HisSearchItem[] {
        let criteriaItems: HisSearchItem[] = [];
        for (let searchItem of searchItems) {
            if (searchItem.key.startsWith(criteriaWithIndex)) {
                criteriaItems.push(searchItem);
            }
        }
        return criteriaItems;
    }

    /**
     * Gets the search criteria for the prefixWithIndex
     *
     * @param prefixWithIndex E. g. groups[0] or groups[0].criteriaGroups[0]
     * @param criteriaItems the item from which to select the searchItems
     *
     * @returns an array of HisSearchCriteria with the criteria for the prefixWithIndex
     */
    static getSearchCriteria(prefixWithIndex: string, criteriaItems: HisSearchItem[]): HisSearchCriteria[] {
        let criteriaIndexes = this.getIndexesOfType(prefixWithIndex, HisSearchConstants.CRITERIA, criteriaItems);
        let searchCriteria: HisSearchCriteria[] = [];
        for (let index of criteriaIndexes) {
            let criteriaWithIndex = prefixWithIndex + '.' + HisSearchConstants.CRITERIA + index;
            let criteria = this.getCriteriaItemsForIndex(criteriaWithIndex, criteriaItems);
            let searchCriterion = new HisSearchCriteria();
            let field = criteria.find(item => item.key.endsWith(HisSearchConstants.FIELD));
            if (field) {
                searchCriterion.field = field.value;
            }

            let value = criteria.find(item => item.key.endsWith(HisSearchConstants.VALUE));
            if (value) {
                searchCriterion.value = value.value;
            }

            let not = criteria.find(item => item.key.endsWith(HisSearchConstants.NOT));
            if (not) {
                if (not.value === 'true') {
                    searchCriterion.not = true;
                } else {
                    searchCriterion.not = false;
                }
            }

            let operator = criteria.find(item => item.key.endsWith(HisSearchConstants.OPERATOR));
            if (operator) {
                if (operator.value === '=') {
                    searchCriterion.operator = HisSearchCriteriaOperator.EQ;
                }
                if (operator.value === '<>') {
                    searchCriterion.operator = HisSearchCriteriaOperator.NE;
                }
                if (operator.value === '>') {
                    searchCriterion.operator = HisSearchCriteriaOperator.GT;
                }
                if (operator.value === '<') {
                    searchCriterion.operator = HisSearchCriteriaOperator.LT;
                }
            }

            searchCriteria.push(searchCriterion);
        }

        return searchCriteria;
    }

    /**
     * @param searchItems the searchItems from which to select the criteria items
     * @param groupPrefixWithIndex the group prefix with the index
     *
     * @returns an array of HisSearchItem with the criteria items for the group
     */
    static getCriteriaItemsForGroup(groupPrefixWithIndex: string, searchItems: HisSearchItem[]): HisSearchItem[] {
        let criteriaItems: HisSearchItem[] = [];
        for (let searchItem of searchItems) {
            if (searchItem.key.startsWith(groupPrefixWithIndex + '.' + HisSearchConstants.CRITERIA)) {
                criteriaItems.push(searchItem);
            }
        }
        return criteriaItems;
    }

    /**
     * Adds the group label
     */
    static addGroupLabel(groupWithIndex: string, sortedGroupItems: HisSearchItem[]): string {
        let labelKey = groupWithIndex  + '.' + HisSearchConstants.GROUP_LABEL;
        let labelItem = this.findItemWithKey(labelKey, sortedGroupItems);
        // console.log('labelItem', labelKey, labelItem);
        if (labelItem) {
            return labelItem.value;
        }
        return undefined;
    }

    /**
     * Adds the value for group.and that shows in case of two or more groups
     * if they are concated with AND or wirth OR
     */
    static addGroupConcatedWithAND(groupWithIndex: string, sortedGroupItems: HisSearchItem[]): boolean {
        let andKey = groupWithIndex  + '.' + HisSearchConstants.CRITERIA_GROUP_AND;
        let andItem = this.findItemWithKey(andKey, sortedGroupItems);
        console.log('his-search-parser#addGroupConcatedWithAND() #andItem', andItem);
        if (andItem) {
            if (andItem.value === 'true') {
                return true;
            }
            if (andItem.value === 'false') {
                return false;
            }
        }
        return undefined;
    }

    /**
     * @param key a key like groups[0].label, groups[0].and
     * @param searchItems the searchItems from which to select the items
     *
     * @returns an array of HisSearchItem with the item of the key
     */
    static findItemWithKey(key: string, items: HisSearchItem[]): HisSearchItem {
        for (let item of items) {
            if (item.key === key) {
                return item;
            }
        }
        return undefined;
    }

    static getValueForKey(key: string, defaultValue: any, searchItems: HisSearchItem[]): string {
        for (let searchItem of searchItems) {
            if (searchItem.key.startsWith(key)) {
                return searchItem.value;
            }
        }
        return defaultValue;
    }

    /**
     * Extracts, on base of group.label, the indexes of the existing groups
     *
     * @returns an array with the indexes of the existing groups
     */
    static getGroupIndexes(searchItems: HisSearchItem[]): number[] {
        let groupIndexes: number[] = [];
        for (let searchItem of searchItems) {

            // Annahme: jede Gruppe hat ein Label
            if (searchItem.key.endsWith('.' + HisSearchConstants.GROUP_LABEL)) {
                let index = searchItem.key.replace(HisSearchConstants.GROUPS, '').replace('.' + HisSearchConstants.GROUP_LABEL, '');
                console.log('his-search-parser#getGroupIndexes', '#index', index);
                groupIndexes.push(Number(index));
            }
        }
        return groupIndexes;
    }
}
